<template>
  <div id="add-chart" class="row">
    <div class="col-md-6">
      <div :class="'img-charts ' + cekChart(1)" data-id="1">
        <img
          style="width: 100%"
          src="assets/img/charts/grafik-mention-reach-engagement.png"
          alt=""
        />
        <center><span>Grafik Mention, Reach, dan Engagement</span></center>
      </div>
    </div>
    <div class="col-md-6">
      <div :class="'img-charts ' + cekChart(4)" data-id="4">
        <img
          style="width: 100%"
          src="assets/img/charts/grafik-mention-by-topik.png"
          alt=""
        />
        <center><span>Grafik Komparasi Topik</span></center>
      </div>
    </div>
    <div class="col-md-6">
      <div :class="'img-charts ' + cekChart(2)" data-id="2">
        <img
          style="width: 100%"
          src="assets/img/charts/grafik-mention-by-sources.png"
          alt=""
        />
        <center><span>Grafik Mention By Sources</span></center>
      </div>
    </div>
    <div class="col-md-6">
      <div :class="'img-charts ' + cekChart(3)" data-id="3">
        <img
          style="width: 100%"
          src="assets/img/charts/grafik-sentimen.png"
          alt=""
        />
        <center><span>Grafik Sentimen</span></center>
      </div>
    </div>
    <div class="col-md-6">
      <div :class="'img-charts ' + cekChart(10)" data-id="10">
        <img
          style="width: 100%"
          src="assets/img/charts/grafik-sentimen.png"
          alt=""
        />
        <center><span>Grafik Emotion</span></center>
      </div>
    </div>
    <div class="col-md-12" align="right">
      <button class="btn btn-danger m-r-10" @click="closeModal">Batal</button>
      <button class="btn btn-success" @click="addChart">Simpan</button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "modal_add_medsos_chart",
  props: {
    data: Array,
  },
  data() {
    return {
      selected_charts: this.data,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    addChart: function () {
      let api = process.env.VUE_APP_API_URL + "project-chart";
      let param = {
        _id: this.id_project,
        charts: this.selected_charts,
      };
      this.$http
        .post(api, param)
        .then((response) => {
          if (response.status == 200) {
            let project = this.$store.getters.user.project;
            project.project_detail.charts = this.selected_charts;
            this.$store.dispatch("user_project", project);
            this.$parent.$parent.initChartAnalytic();
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Grafik berhasil diupdate!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan. Silahkan coba lagi!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.closeModal();
        });
    },
    closeModal: function () {
      $("#modalSlideUp").modal("hide");
    },
    cekChart: function (id) {
      let selected_class = "";
      if (this.selected_charts.includes(id)) {
        selected_class = "chart-selected";
      }
      return selected_class;
    },
  },
  mounted: function () {
    let self = this;
    $(".img-charts").on("click", function () {
      let chart_id = $(this).attr("data-id");
      chart_id = parseInt(chart_id);
      if ($(this).hasClass("chart-selected")) {
        if (self.selected_charts.includes(chart_id)) {
          let index = self.selected_charts.indexOf(chart_id);
          self.selected_charts.splice(index, 1);
        }
        $(this).removeClass("chart-selected");
      } else {
        if (!self.selected_charts.includes(chart_id)) {
          self.selected_charts.push(chart_id);
        }
        $(this).addClass("chart-selected");
      }
    });
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
.img-charts {
  margin-bottom: 20px;
}
.img-charts:hover {
  cursor: pointer;
}
.chart-selected {
  border: 2px solid blue;
}
</style>